const e: any = process.env;
const must = (k: string) => {
    const v = e[k];
    if (!v) throw new Error(`Missing required env: ${k}`);
    return v;
};

export const GATEWAY_BASE = must('REACT_APP_API_GATEWAY_BASE_URL');

export const SEC_13F_PATH = e.REACT_APP_API_SEC_13F_PATH ?? '/sec/v1';
export const LOGIN_PATH   = e.REACT_APP_API_LOGIN_PATH   ?? '/oauth2/login';
export const LOGOUT_PATH = e.REACT_APP_API_LOGOUT_PATH ?? '/oauth2/logout';
export const OAUTH_TOKEN_PATH  = e.REACT_APP_API_OAUTH2_TOKEN_PATH ?? '/oauth2/token';

export const OAUTH_CALLBACK_BASE_PATH =
    e.REACT_APP_OAUTH_CALLBACK_BASE_PATH ?? '/oauth2/callback';

export const API_TIMEOUT_MS = Number(e.REACT_APP_API_TIMEOUT_MS ?? '10000');

export const OAUTH = {
    GOOGLE: {
        authUrl: must('REACT_APP_OAUTH_AUTH_URL_GOOGLE'),
        scope:   must('REACT_APP_OAUTH_SCOPE_GOOGLE'),
        clientId:must('REACT_APP_SSO_GOOGLE_CLIENT_ID'),
    },
    MICROSOFT: {
        authUrl: must('REACT_APP_OAUTH_AUTH_URL_MICROSOFT'),
        scope:   must('REACT_APP_OAUTH_SCOPE_MICROSOFT'),
        clientId:must('REACT_APP_SSO_MICROSOFT_CLIENT_ID'),
    }
} as const;

const ENV_NAME = (process.env.REACT_APP_ENV || "").toLowerCase();
const URL_HINTS_SANDBOX = /sandbox/i.test(process.env.REACT_APP_API_GATEWAY_BASE_URL || "");
export const IS_SANDBOX_ENV = ENV_NAME === "sandbox" || URL_HINTS_SANDBOX;

export const SANDBOX_AUTOLOGIN =
    (process.env.REACT_APP_SANDBOX_AUTOLOGIN ?? (IS_SANDBOX_ENV ? "true" : "false")) === "true";

export const SANDBOX_EMAIL =
    process.env.REACT_APP_AUTH_PRESET_EMAIL || "";

export const SANDBOX_PASSWORD =
    process.env.REACT_APP_AUTH_PRESET_PASSWORD || "";
